<template>
  <div class="main-content-container">
    <div class="container">
      <!-- Page Header -->
      <div class="page-header row no-gutters py-4">
        <div class="col-6 text-center text-sm-left mb-0">
          <span class="text-uppercase page-subtitle">sessão</span>
          <h3 class="page-title">Subcontas com Chargeback</h3>
        </div>
      </div>

      <!-- Default Light Table -->
      <div class="row">
        <div class="col">
          <div class="card card-small mb-4">
            <div class="card-header border-bottom">
              <div class="float-left">
                <h6 class="m-0">Subcontas</h6>
              </div>
              <div v-if="pagination.TotalItems > 0" class="float-right">
                <b-input-group class="d-flex justify-content-end my-auto ml-2">
                  <h6 v-if="pagination.TotalItems > 0" class="m-0">
                    {{ pagination.TotalItems | number }}
                    {{ pagination.TotalItems > 1 ? " itens" : "item" }}
                  </h6>
                  <div class="dropdown m-0" v-if="pagination.TotalItems > 1">
                    <button
                      class="btn btn-outline-secondary dropdown-toggle-ellipsis"
                      type="button"
                      v-b-tooltip.hover.right
                      title="Mais opções"
                      id="dropdownMenuButton"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <i class="fas fa-ellipsis-v"></i>
                    </button>
                    <div
                      class="dropdown-menu"
                      id="dropTableOptions"
                      aria-labelledby="dropdownMenuButton"
                    >
                      <a
                        class="dropdown-item"
                        href="#"
                        :class="loadingReport ? 'disabled' : ''"
                        v-on:click.stop="GetReport($event)"
                      >
                        <template v-if="loadingReport">
                          <loader
                            :small="true"
                            :isLoading="loadingReport"
                          ></loader>
                        </template>
                        <template v-else>
                          <i class="fas fa-check mr-2"></i>
                          Gerar relatório
                        </template>
                      </a>
                    </div>
                  </div>
                </b-input-group>
              </div>
            </div>
            <div class="card-body p-0 pb-3 text-center">
              <loader :is-loading="loadingList"></loader>
              <table class="table mb-0" v-if="!loadingList">
                <thead class="bg-s2p-gray-light">
                  <tr>
                    <th scope="col" class="border-0"></th>
                    <th scope="col" class="border-0 text-left">
                      {{ labelIdMerchant }}
                    </th>
                    <th scope="col" class="border-0 text-left">
                      {{ labelIdMerchantRoot }}
                    </th>
                    <th scope="col" class="border-0 text-left">
                      {{ labelName }}
                    </th>
                    <th scope="col" class="border-0">
                      {{ labelCountPerformed }}
                    </th>
                    <th scope="col" class="border-0">
                      {{ labelAmountChargeback }}
                    </th>
                    <th scope="col" class="border-0">
                      {{ labelAmountChargebackPaid }}
                    </th>
                    <th scope="col" class="border-0">
                      {{ labelCountAuthorized }}
                    </th>
                    <th scope="col" class="border-0">
                      {{ labelCountChargeback }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(subaccount, index) in subaccounts" :key="index">
                    <td></td>
                    <td class="text-left">{{ subaccount.Merchant.Id }}</td>
                    <td class="text-left">
                      {{ subaccount.Merchant.IdMerchantRoot }}
                    </td>
                    <td class="text-left">{{ subaccount.Merchant.Name }}</td>
                    <td>{{ subaccount.CountPerformed }}</td>
                    <td>{{ subaccount.AmountChargeback | currency }}</td>
                    <td>
                      {{ subaccount.AmountChargebackPaid | currency }}
                    </td>
                    <td>{{ subaccount.CountAuthorized }}</td>
                    <td>{{ subaccount.CountChargeback }}</td>
                  </tr>
                  <tr
                    v-if="
                      subaccounts == undefined ||
                      subaccounts == null ||
                      subaccounts.length == 0
                    "
                  >
                    <td colspan="5">Sem registros</td>
                  </tr>
                </tbody>
              </table>

              <div class="col-12 border-top">
                <div class="pagination-nav">
                  <b-pagination
                    class="float-right"
                    v-model="pagination.PageNumber"
                    :total-rows="pagination.TotalItems"
                    :per-page="pagination.RowsPerPage"
                    aria-controls="my-table"
                  ></b-pagination>
                  <div class="float-left">
                    <d-select size="sm" v-model="pagination.RowsPerPage">
                      <option value="5">5</option>
                      <option value="10">10</option>
                      <option value="30">30</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                      <option value="200">200</option>
                      <option value="500">500</option>
                    </d-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { hasValue } from "../../utils/functions.js";
import dateField from "../common/date-field";
export default {
  name: "chargeback-dashboard-brand",
  components: {
    dateField,
  },
  data: function () {
    return {
      subaccounts: [],
      labelIdMerchant: "Id Empresa",
      labelIdMerchantRoot: "Id Marketplace",
      labelName: "Empresa",
      labelIdentity: "CPF/CNPJ",
      labelCountPerformed: "Qtd transações realizadas",
      labelAmountChargeback: "Valor transacionado",
      labelAmountChargebackPaid: "Valor repassado",
      labelCountAuthorized: "Qtd autorizadas",
      labelCountChargeback: "Qtd chargeback/em disputa",
      loadingList: false,
      loadingReport: false,
      pagination: {
        PageNumber: 1,
        RowsPerPage: 10,
        TotalItems: 0,
      },
    };
  },
  computed: {},
  watch: {
    "pagination.PageNumber": function () {
      this.ListChargebacks();
    },
    "pagination.RowsPerPage": function () {
      this.ListChargebacks();
    },
  },
  mounted() {
    this.idMerchantRoot = this.$route.params.idMerchantRoot;
    this.initialDate = this.$route.query.InitialDate;
    this.endDate = this.$route.query.EndDate;
    this.ListChargebacks();
  },
  methods: {
    OpenModalFilter: function () {
      this.$bvModal.show("mFilter");
    },
    Filter: function () {
      this.$bvModal.hide("mFilter");
      this.ListChargebacks();
    },
    ListChargebacks: function () {
      this.loadingList = true;
      let data = {
        ...this.pagination,
        ...{
          "Object.IdMerchantRoot": this.idMerchantRoot,
          "Object.InitialDate": this.initialDate,
          "Object.EndDate": this.endDate,
        },
      };
      delete data.TotalItems;
      this.$store
        .dispatch("ChargebackListSubaccount", { params: data })
        .then((response) => {
          this.subaccounts = response.Objects;
          this.pagination.TotalItems = response.TotalItems;
        })
        .catch((error) => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao listar as subcontas com chargeback",
            error
          );
        })
        .finally(() => (this.loadingList = false));
    },
    GetReport: function (ev) {
      ev.preventDefault();
      this.loadingReport = true;
      const params = {
        ...this.pagination,
        ...{
          "Object.IdMerchantRoot": this.idMerchantRoot,
          "Object.InitialDate": this.initialDate,
          "Object.EndDate": this.endDate,
        },
      };
      this.$store
        .dispatch("ReportSubaccount", { params: params })
        .then((response) => {
          if (
            response.UrlReport != null &&
            response.UrlReport != undefined &&
            response.UrlReport != ""
          ) {
            this.$makeToast(
              "Aguarde a conclusão do download",
              "info",
              "Relatório gerado com sucesso"
            );
            window.open(response.UrlReport, "_self");
          }
        })
        .catch((error) => {
          this.$makeToast(
            "Tente novamente mais tarde.",
            "danger",
            "Erro ao gerar o relatório",
            error
          );
        })
        .finally(() => {
          $("#dropTableOptions").dropdown("hide");
          setTimeout(() => {
            this.loadingReport = false;
          }, 1200);
        });
    },
    ResetFilter: function () {
      this.filter = {
        NameCustomer: null,
        NameMerchant: null,
        IdMerchant: null,
        IdMerchantRoot: null,
      };
      this.GetBrand(this.idBrand);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/chargebacksMarketplace.vue